import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Existing saveExhibitors async thunk remains unchanged
export const saveExhibitors = createAsyncThunk(
  'exhibitors/saveExhibitors',
  async (exhibitors, thunkAPI) => {
    try {
      const responses = [];
      for (const exhibitor of exhibitors) {
        const formData = new FormData();
        formData.append('name', exhibitor.name);
        formData.append('description', exhibitor.description);
        formData.append('woocommerce_product_id', exhibitor.woocommerce_product_id);
        if (exhibitor.img) {
          formData.append('img', exhibitor.img);
        }

        const response = await axios.post('/api/create-keyexhibitor', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        responses.push(response.data);
      }
      return responses;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'An unexpected error occurred');
    }
  }
);

// New: Fetch existing exhibitor by ID
export const fetchExhibitor = createAsyncThunk(
  'exhibitors/fetchExhibitor',
  async (woocommerce_product_id, thunkAPI) => {
    try {
      const response = await axios.get(`/api/getkeyexhibitor/${woocommerce_product_id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch exhibitor');
    }
  }
);

// New: Update existing exhibitor
export const updateExistingExhibitor = createAsyncThunk(
  'exhibitors/updateExistingExhibitor',
  async ({ id, updatedData }, thunkAPI) => {
    try {
      const formData = new FormData();
      for (const key in updatedData) {
        formData.append(key, updatedData[key]);
      }
      const response = await axios.put(`/api/updatekeyexhibitor/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to update exhibitor');
    }
  }
);
//delete exhibitor
export const deleteExhibitor = createAsyncThunk(
  'exhibitors/deleteExhibitor',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`/api/deletekeyexhibitor/${id}`);
      return id; // Return the deleted ID so it can be removed from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete exhibitor');
    }
  }
);


// Slice
const keyExhibitorsSlice = createSlice({
  name: 'exhibitors',
  initialState: {
    exhibitors: [],
    status: 'idle',
    error: null,
    selectedExhibitor: null,
  },
  reducers: {
    addExhibitor: (state) => {
      state.exhibitors.push({
        id: Date.now(),
        name: '',
        img: '',
        description: '',
        woocommerce_product_id: null,
      });
    },
    removeExhibitor: (state) => {
      if (state.exhibitors.length > 1) {
        state.exhibitors.pop();
      }
    },
    updateExhibitor: (state, action) => {
      const { index, field, value } = action.payload;
      state.exhibitors[index][field] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      // Existing saveExhibitors handlers remain unchanged
      .addCase(saveExhibitors.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveExhibitors.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(saveExhibitors.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // New: fetchExhibitor handlers
      .addCase(fetchExhibitor.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchExhibitor.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedExhibitor = action.payload;
      })
      .addCase(fetchExhibitor.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // New: updateExistingExhibitor handlers
      .addCase(updateExistingExhibitor.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateExistingExhibitor.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Optionally update the exhibitor in the state
        const updatedIndex = state.exhibitors.findIndex(
          (exhibitor) => exhibitor.id === action.payload.id
        );
        if (updatedIndex !== -1) {
          state.exhibitors[updatedIndex] = action.payload;
        }
      })
      .addCase(updateExistingExhibitor.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
// New: deleteExhibitor handlers
.addCase(deleteExhibitor.pending, (state) => {
  state.status = 'loading';
  state.error = null;
})
.addCase(deleteExhibitor.fulfilled, (state, action) => {
  state.status = 'succeeded';
  state.exhibitors = state.exhibitors.filter(ex => ex.id !== action.payload);
})
.addCase(deleteExhibitor.rejected, (state, action) => {
  state.status = 'failed';
  state.error = action.payload;
})


  },
});

export const { addExhibitor, removeExhibitor, updateExhibitor } = keyExhibitorsSlice.actions;

export default keyExhibitorsSlice.reducer;

